import { Tilelet } from "@vds/tiles";
import { Title, Body } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { GetFooterNotes, GetHelperText, GetPlanPageDetails, GetSelectedDeviceDetails } from "../../shared/components/GetPlanPageDetails.jsx";
import { useSelector } from 'react-redux';
import { getDestList } from '../../shared/utils/globalUtils';
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, unauth, unauthItpNsaFFlag,reloadRedirectFixFFlag } from '../../shared/utils/globalConfig';
import inflightDesktop from '../../assets/images/inflight_desktop.png'
import inflightMobile from '../../assets/images/inflight_mobile.png';
import inflightTablet from '../../assets/images/inflight_tablet.png';
import ReviewModal from '../../pages/ITP/ReviewModal';
import { dispatchPageView } from '../../shared/utils/tagging';
import { saveSelectedDeviceDetails } from '../../features/selectedData/selectedDataReducer';
import {getDevicesPayload } from '../../shared/utils/globalUtils';
import xss from 'xss';

const CruisePlanSelectionMain = styled.div`
`
const Space = styled.div`
padding-top: ${props => props.pt || 24}px;
`

export default function CruisePlanSelection() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedDestinations, selectedDates,selectedDeviceDetailsUnauth, onlyCruise } = useSelector(state => state?.persistantReducer);
    
    const { selectedDeviceDetails } = useSelector(state => state?.selectedReducer);
    

    const getsDevicesPayloadUnauth = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payload;
    }
    
    const Payload = unauth ? getsDevicesPayloadUnauth() : getDevicesPayload(selectedDates, selectedDestinations);
    const { data, isLoading,} = useGetDevicesAndPlansByNameQuery(Payload,{ skip: unauth && (Object.keys(selectedDeviceDetailsUnauth).length == 0 || selectedDestinations?.length === 0)})

    const [planPageDetails, setPlanDetails] = useState();
    const [showReviewModal, setReviewModal] = useState(false);

    useEffect(() => {
        setPlanDetails(data?.body?.data?.planDetailsSea)

    }, [data]);
    //Redirect to destination, if destination and travel dates are empty
    useEffect(() => {

        if ((selectedDestinations.length === 0 || selectedDates?.travelStartDate == undefined && selectedDates?.travelEndDate == undefined) && reloadRedirectFixFFlag) {
            if (unauth) {
                window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
            }
            else {
                window.location.href = xss('/digital/nsa/secure/ui/intl/trip/');
            }
        }
    }, [])

     //saveSelectedDeviceDetails from planpage response for unauth flow
     useEffect(() => {
        if(unauth && onlyCruise) 
           {
            dispatch(saveSelectedDeviceDetails(data?.body?.data?.devicesAndPlans?.deviceDetails[0])); 
           } 
    }, [data]);

    useEffect(() => {
         if(!onlyCruise || !unauth){
            if (Object.keys(selectedDeviceDetails).length === 0) {
                navigate(-1, { replace: true })
            }
        }
    }, [selectedDeviceDetails])

        //Tagging
    useEffect(() => {
        dispatchPageView('ITP_CruisePlanSelection','cruise plan selection','#cruise_selection');
    },[])

    const getSeaPlans = () => {
        let plans = [];
        let criuseplans = planPageDetails?.cruisePlanInfo.map((plan) => {
            if (plan?.planTypeName === 'CRUISE_DAILY_PASS' && selectedDeviceDetails.cruisePlan) {
                let cruisePlanUpdated = JSON.parse(JSON.stringify(plan))
                cruisePlanUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsCruise;
                plans.push(cruisePlanUpdated);
            }
            if (plan?.planTypeName === 'PAYGO_SEA' && selectedDeviceDetails.payAsYouGoSea) {
                let payAsYouGoSeaUpdated = JSON.parse(JSON.stringify(plan))
                payAsYouGoSeaUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsPaygoSea;
                plans.push(payAsYouGoSeaUpdated);
            }
        })
        return plans;
    }
    const onTileClick = () => {
        setReviewModal(true);
    }

    return (
        <CruisePlanSelectionMain id="cruise_selection">
            {(!isLoading && planPageDetails)
                ?
                <>
                    <GetSelectedDeviceDetails planType="sea"/>
                    <Space />
                    <Title size="XLarge">{planPageDetails?.cruisePageTitle}</Title>
                    <Space />
                    <Body size="large">{planPageDetails?.cruisePageHeading}</Body>
                    {planPageDetails?.discountedCustomer && <><Space /><Body size="large">{planPageDetails?.discountedPlans}</Body></>}
                    <GetPlanPageDetails availablePlans={getSeaPlans()} theme='monarch' planType={'sea'} />
                    <GetHelperText subHeadingText={planPageDetails?.subHeadingText} />
                    <Space pt={32}></Space>
                    {selectedDeviceDetails?.inflightPlan && <><Title size="Xlarge " bold >{planPageDetails?.inflightDataObject?.alsoAvailableText}</Title>
                        <Space ></Space>
                        <Tilelet
                            title={{
                                size: 'titleMedium',
                                children: planPageDetails?.inflightDataObject?.planName,
                                primitive: 'h1',
                            }}
                            subtitle={{
                                size: 'bodyLarge',
                                children: planPageDetails?.inflightDataObject?.planDesc,
                                primitive: 'h1',

                            }}
                            directionalIcon={{
                                name: 'right-arrow',
                                size: 'medium',
                            }}
                            surface='light'
                            width={isDesktop ? '45%' : '100%'}
                            height={isDesktop ? '300px' : '185px'}
                            onClick={() => { onTileClick() }}
                            showBorder={true}
                            backgroundColor='black'
                            backgroundImage={planPageDetails?.inflightDataObject?.planImageUrl} />
                    </>}<Space pt={32}></Space>
                    <GetFooterNotes footerNotes={planPageDetails?.cruiseFooterNotes} />

                    {showReviewModal &&
                        <ReviewModal
                            setReviewModal={setReviewModal}
                            showReviewModal={showReviewModal}
                            PlanData={data?.body?.data?.inFlightReviewDetailObject}
                        />
                    }
                </>
                :
                <FullPageLoader></FullPageLoader>}
        </CruisePlanSelectionMain>

    );
} 